import classnames from 'classnames'
import { useEffect, useState } from 'react'

import useClickOutSide from '@src/quince-site-common/src/hooks/useClickOutSide'
import { trackEvent } from '@src/telemetry/track'

import DownArrowIcon from '../../../icons/downArrow.inline.svg'

import styles from './select.module.scss'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { ProductProperties } from '@src/telemetry/getProductPropertiesForTracking'

export interface SelectOptionProps {
  label: string
  value: string
}

export interface SelectProps {
  options: SelectOptionProps[]
  label: string
  onChange: (val: string) => void
  className?: string
  labelClassName?: string
  variants?: any
  hasPhoto?: boolean
  productProperties: ProductProperties
}

export const Select = ({
  className = '',
  labelClassName = '',
  options,
  label,
  onChange,
  variants,
  hasPhoto,
  productProperties,
}: SelectProps) => {
  const [selected, setSelectedVal] = useState('')
  const { ref, isOpen, setIsOpen } = useClickOutSide()
  useEffect(() => {
    onChange(selected)
  }, [onChange, selected])

  return (
    <div className={classnames(styles.selectBoxWrap, className)} ref={ref}>
      <div
        data-testid="review-section-sortby-heading"
        className={classnames('dropdownTitle', styles.dropdownTitle, labelClassName)}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        <span className={styles.label}>{label}</span>{' '}
        <DownArrowIcon className={classnames(styles.dropdownIcon, { [styles.open]: isOpen })} />
      </div>
      <ul
        data-testid="review-section-sortby-content"
        className={classnames(styles.optionsWrap, { [styles.show]: isOpen })}
      >
        {options.map((item: SelectOptionProps) => {
          return (
            <li
              data-testid={`review-section-sortby-value-${item.value}}`}
              key={item.label}
              onClick={() => {
                setSelectedVal(item.value)
                setIsOpen(false)
                trackEvent(TELEMETRY_EVENT_NAMES.REVIEWS_SORTED, {
                  product_id: variants[0]?.productId,
                  has_photo_filter: hasPhoto,
                  productProperties: productProperties,
                })
              }}
              className={classnames(styles.optionItem, {
                [styles.selected]: item.value === selected,
              })}
            >
              {item.label}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default Select
